import { ComparableDepositExtended } from '@/page-src/product/pages/deposits/api';
import { URL_PATH } from '@/src/constants/url-path';
import {
  trackClickToEnterListFinancialProductSearchDetail,
  trackIssueProductFinancialProductSearchDetail,
} from '@/src/events/trackers/product/deposits/product-guid';
import { WEB_BASE_URL } from '@/src/utils/link';

export const getDepositsMainInfoIssueUrlAndButtonText = (result: ComparableDepositExtended) => {
  const { deposit } = result;
  if (!deposit.isExposable || deposit.isStopped) {
    return {
      text: `금리 1위 예금 상품은?`,
      urlPath: `${WEB_BASE_URL}${URL_PATH.CHART_DEPOSITS}`,
      clickTracker: (location: 'floating' | 'fixed') => {
        trackClickToEnterListFinancialProductSearchDetail(deposit, location);
      },
    };
  }

  if (deposit.issueUrl === undefined) {
    return {
      text: '상품 정보를 준비 중입니다',
      urlPath: undefined,
      clickTracker: undefined,
    };
  }

  return {
    text: `${deposit.organization.name}에서 보기`,
    urlPath: deposit.issueUrl,
    clickTracker: (location: 'floating' | 'fixed') => {
      trackIssueProductFinancialProductSearchDetail(deposit, location);
    },
  };
};
